import { t } from "./i18n";

export interface DiagnosisOption {
  key: string;
}

const diagnoses: DiagnosisOption[] = [
  { key: "cancer" },
  { key: "alzheimers" },
  { key: "stroke" },
  { key: "copd" },
  { key: "chf" },
  { key: "neurologic" },
  { key: "huntingtons" },
  { key: "md-ibm" },
  { key: "myasthenia" },
  { key: "renal" },
  { key: "liver" },
  { key: "hiv" },
];

export function renderDiagnosisSelect(
  container: HTMLElement,
  onSelect: (diagnosisKey: string) => void,
  onBack: () => void
): void {
  while (container.firstChild) container.removeChild(container.firstChild);

  const wrapper = document.createElement("div");
  wrapper.className = "diagnosis-select";

  const heading = document.createElement("h2");
  heading.textContent = t("ui.diagnosis.title");
  wrapper.appendChild(heading);

  const subtext = document.createElement("p");
  subtext.className = "diagnosis-subtext";
  subtext.textContent = t("ui.diagnosis.subtext");
  wrapper.appendChild(subtext);

  const optionsContainer = document.createElement("div");
  optionsContainer.className = "diagnosis-options";

  diagnoses.forEach((diagnosis) => {
    const card = document.createElement("button");
    card.className = "diagnosis-card";
    card.type = "button";

    const label = document.createElement("span");
    label.className = "diagnosis-label";
    label.textContent = t(`ui.diagnosis.${diagnosis.key}.label`);
    card.appendChild(label);

    const desc = document.createElement("span");
    desc.className = "diagnosis-description";
    desc.textContent = t(`ui.diagnosis.${diagnosis.key}.description`);
    card.appendChild(desc);

    card.addEventListener("click", () => onSelect(diagnosis.key));
    optionsContainer.appendChild(card);
  });

  wrapper.appendChild(optionsContainer);

  const backBtn = document.createElement("button");
  backBtn.className = "btn-secondary";
  backBtn.textContent = t("ui.nav.back");
  backBtn.addEventListener("click", onBack);
  wrapper.appendChild(backBtn);

  container.appendChild(wrapper);
}
